import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Reload once when a newly deployed version takes over.
//
// The service worker is configured with skipWaiting + clientsClaim, so a new
// build activates as soon as it's downloaded — but the page already on screen
// keeps running the old code until something reloads it. In practice that
// meant a phone could sit on a build one or two versions behind while
// appearing perfectly up to date, which cost real time during testing: a fix
// would be deployed, tested, and appear not to work.
//
// The guard matters. controllerchange also fires the first time a service
// worker takes control of a page that had none, and reloading unconditionally
// on that would loop.
if ('serviceWorker' in navigator) {
  // Only a CHANGE of controller means a new version took over. On a first
  // visit there is no controller yet, and the worker claiming the page also
  // fires this event — reloading then would be pointless churn.
  const hadController = Boolean(navigator.serviceWorker.controller);
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
